import { NgModule } from '@angular/core';
import { CostRouting } from './cost.routing';
import { CostComponent } from './cost.component';
import { QuotationQuotationsResourceModule } from "libraries/service/resources/quotation-quotations/quotation-quotations-resource.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { CommonModule } from "@angular/common";
import { LabelModule } from "libraries/service/label/label.module";
import { QuotationBreadcrumbModule } from "app_quotation/shared/components/breadcrumb/quotation-breadcrumb.module";
import { InstanceModule } from "libraries/service/instance/instance.module";
import { CostGridModule } from "./components/cost-grid/cost-grid.module";
import { QuotationLayoutModule } from "app_quotation/shared/components/quotation-layout/quotation-layout.module";
import { AppHeaderTitleQuotationModule } from 'app_quotation/shared/services/app-header-title-quotation/app-header-title-quotation.module';
import { CostAppConfigModule } from './services/cost-app-config/cost-app-config.module';
import { ErrorTracingModule } from "libraries/service/error-tracing/error-tracing.module";
import { TabNavigationModule } from 'libraries/component/tab-navigation/tab-navigation.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { GridTabNavigationModule } from '../../shared/components/grid-tab-navigation/grid-tab-navigation.module';
import { RateInvalidityNotificationModule } from 'app_quotation/shared/components/rate-invalidity-notification/rate-invalidity-notification.module';
import { XRateModule } from 'app_quotation/shared/services/xRate/xRate.module';
import { CostWarningModule } from '../../shared/components/cost-warning/cost-warning.module';
import { WatabiUrlModule } from './services/watabi-url/watabi-url.module';
import {
    ExchangeRateInformationModule
} from "../../shared/components/exchange-rate-information/exchange-rate-information.module";

@NgModule({
    imports: [
        CommonModule,
        CostGridModule,
        CostWarningModule,
        CostRouting,
        ExchangeRateInformationModule,
        InstanceModule,
        LabelModule,
        LoaderModule,
        NotificationModule,
        QuotationBreadcrumbModule,
        QuotationLayoutModule,
        QuotationQuotationsResourceModule,
        AppHeaderTitleQuotationModule,
        CostAppConfigModule,
        ErrorTracingModule,
        TabNavigationModule,
        BtnModule,
        GridTabNavigationModule,
        RateInvalidityNotificationModule,
        XRateModule,
        WatabiUrlModule,
    ],
    exports: [CostComponent],
    declarations: [CostComponent],
})
export class CostModule { }
